import vttToJson from "./vtt-to-json";
/**
 * 注册自定义player插件
 */
(function () {
    var drawSvg = (pathDatas, width = 200, height = 200) => {
        let iconSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
        pathDatas.map(path => {
            let iconPath = document.createElementNS('http://www.w3.org/2000/svg', 'path')
            iconPath.setAttribute('d', path)
            iconSvg.appendChild(iconPath)
        })
        iconSvg.setAttribute("width", width);
        iconSvg.setAttribute("height", height);
        iconSvg.setAttribute("x", "0");
        iconSvg.setAttribute("y", "0");
        iconSvg.setAttribute("fill", "#fff");
        iconSvg.setAttribute("viewBox", "0 0 1024 1024");
        iconSvg.style.display = 'inline-block'
        return iconSvg
    }
    //记忆播放保存进度插件
    var videoHistoryPlugin = async (player) => {
        let ts = 0
        if (!player.config.memoryPlay) return
        // console.log(player.config.videoHistoryParams)
        // let {id, chapterId, courseId, sectionId, subsectionId, videoId} = player.config.videoHistoryParams
        player.saveVideoHistory = function () {
            let { id, chapterId, courseId, sectionId, subsectionId, videoId, courseSemester = '' } = player.config.videoHistoryParams
            let watchTime = player.currentTime * 10000000
            let totalWatchTime = player.config.videoHistoryParams.totalWatchTime
            if (!watchTime) return
            if (id) {
                console.log('记录视频位置-更新', {
                    watchTime, id, chapterId, courseId, sectionId, subsectionId, videoId, totalWatchTime, watchTime
                })
                //更新记录
                API.updateVideoHistory({ id, watchTime, totalWatchTime, courseSemester }).then()
            } else {
                console.log('记录视频位置-新增', { watchTime, id, chapterId, courseId, sectionId, subsectionId, videoId })
                //新增记录
                API.saveVideoHistory({
                    chapterId,
                    courseId,
                    sectionId,
                    subsectionId,
                    videoId,
                    watchTime,
                    totalWatchTime,
                    courseSemester
                }).then(res => player.config.videoHistoryParams.id = res.data.id)
            }
        }
        player.on('ended', function () {
            let { id } = player.config.videoHistoryParams
            if (id) {
                //归零
                API.updateVideoHistory({ id, watchTime: 0 }).then()
            }
            ts = 0//取消timeupdate计时
        })
        player.on('timeupdate', function (e) {
            if (!e.hasStart) return
            let newTs = new Date().getTime()
            player.config.videoHistoryParams.totalWatchTime = (newTs - (ts ? ts : newTs)) + (player.config.videoHistoryParams.totalWatchTime || 0)
            ts = newTs
        })
        player.on('pause', function () {
            console.log('player.config.videoHistoryParams', player.config.videoHistoryParams)
            let { id } = player.config.videoHistoryParams
            id && player.saveVideoHistory()
            ts = 0//取消timeupdate计时
        })
    }
    try {
        if (!Player) return
        console.log('记忆播放插件初始化')
        Player.install('videoHistoryPlugin', videoHistoryPlugin)
    } catch {
    }
    //切换浏览器tab栏暂停视频播放插件
    var videoTabChangePause = async (player) => {
        if (document.hidden !== undefined) {
            document.addEventListener('visibilitychange', () => {
                if (document.hidden == true) {
                    // console.log("离开页面")
                    if (player._hasStart) {
                        player.pause()
                    }
                } else {
                    // console.log("进入页面")
                }
            })
        }
    }
    try {
        if (!Player) return
        console.log('tab栏暂停视频播放插件初始化')
        Player.install('videoTabChangePause', videoTabChangePause)
    } catch {
    }

    //播放器行为统计插件
    var videoEventStatisticsPlugin = async (player) => {
        let dateNow = Date.now()
        let catonStartTime //卡顿开始时间
        let currentTime //当前时间
        let hasEnded = false //是否已结束，用于判断是否点击重播
        let volume //音量
        let totalTime = 0
        player.once('play', function () {
            // console.log('点击开始播放')
            //播放器初始化完成后，请求视频地址数据之前触发
            videoEventChange({ eventCode: 'video_pybk_click', eventType: 'CLK' })
        })
        player.once('waiting', function () {
            // console.log('正片加载')
            //在播放器设置播放地址后触发，之后播放器开始请求视频流数据
            videoEventChange({
                eventCode: 'video_positive_load',
                params: { video_duration: player.config.eventStatisticsParams ? player.config.eventStatisticsParams.video_duration : 0 }
            })
        })
        player.once('canplay', function () {
            // console.log('正片播放')
            //播放器回调播放成功事件后触发，即认定为此刻视频第一帧出现
            videoEventChange({ eventCode: 'video_positive_pybk' })
        })
        player.on('timeupdate', function () {
            currentTime = player.currentTime
            let interval = Date.now() - dateNow
            totalTime += interval
            // console.log(interval)
            if (interval >= 20 * 1000) {
                // console.log('心跳')
                //在视频播放从第一帧开始后计数，每间隔20s 触发一次
                videoEventChange({ eventCode: 'heartbeat' })
                dateNow = Date.now()
            }
        })
        player.on('waiting', function () {
            // console.log('卡顿开始')
            //播放过程中播放器无可播放的缓存数据，将播放状态设置为正在缓冲时触发
            videoEventChange({ eventCode: 'caton_begin' })
            catonStartTime = Date.now()
        })
        player.on('canplay', function () {
            // console.log('卡顿结束')
            if (catonStartTime) {
                let caton_duration = ((Date.now() - catonStartTime) / 1000).toFixed(0) //毫秒
                //卡顿过程中播放器请求到视频数据，将缓冲状态设置为播放状态时触发
                videoEventChange({ eventCode: 'caton_end', eventType: 'CLK', params: { caton_duration } })
            }
        })
        player.on('ended', function () {
            // console.log('播放结束点击')
            hasEnded = true
            let duration = player.config.eventStatisticsParams ? player.config.eventStatisticsParams.video_duration : 0
            let scale = totalTime / duration //完播数-完播定义为退出是播放时长大于等于视频长度的90%
            let obj = {
                pybk_duration: parseInt((totalTime / 1000).toFixed(0)),
                full_play_count_25: 0,
                full_play_count_25_50: 0,
                full_play_count_50_75: 0,
                full_play_count_75: 0,
                full_play_count: 0,
            }
            if (scale < 0.25) {
                obj.full_play_count_25 = 1
            } else if (scale < 0.5) {
                obj.full_play_count_25_50 = 1
            } else if (scale < 0.75) {
                obj.full_play_count_50_75 = 1
            } else if (scale < 0.9) {
                obj.full_play_count_75 = 1
            } else {
                obj.full_play_count = 1
            }
            //在播放器销毁之前触发，包括播放器播到视频末尾后自行销毁或页面跳转时对播放器进行的销毁
            videoEventChange({ eventCode: 'video_end_click', eventType: 'CLK', params: { ...obj } })
        })
        player.on('error', function (err) {
            // console.log('播放错误')
            //播放器从初始化开始到播放结束期间，因播放异网络、视频异常等原因报错触发
            videoEventChange({ eventCode: 'pybk_error', params: { error_information: err.ex } })
        })
        player.on('seeking', function () {
            // console.log('时移点击')
            let time_shift_time = player.currentTime //时移移动时点
            time_shift_time = time_shift_time.toFixed(0)
            let time_shift_duration = player.currentTime - currentTime
            time_shift_duration = time_shift_duration.toFixed(0)
            //每一次移动停止时触发。
            videoEventChange({ eventCode: 'time_shift_click', params: { time_shift_time, time_shift_duration } })
        })
        player.on('play', function () {
            if (hasEnded) {
                // console.log('回看点击')
                hasEnded = false
                //点击回看按钮时触发
                videoEventChange({ eventCode: 'pybk_click', eventType: 'CLK' })
            }
        })
        player.on('requestFullscreen', function () {
            // console.log('全屏点击')
            //点击全屏按钮触发
            videoEventChange({ eventCode: 'full_screen_click', eventType: 'CLK' })
        })
        player.on('volumechange', function () {
            // console.log('音量调节拖拽')
            //音量调节停止时触发
            videoEventChange({ eventCode: 'volume_control_drag' })
            if (volume && !player.volume) {
                //点击视频静音时触发
                videoEventChange({ eventCode: 'no_sound_click' })
            }
            if (!volume && player.volume) {
                //点击视频静音恢复时触发
                videoEventChange({ eventCode: 'enable_sound_click' })
            }
            volume = player.volume
        })
        player.on('definitionChange', function ({ from, to }) {
            // console.log('码率切换点击')
            //点击选择具体码率按钮触发
            videoEventChange({ eventCode: 'definition_choice_click', eventType: 'CLK', params: { definition_tyoe: to } })
        })
        player.on('playbackrateChange', function ({ from, to }) {
            // console.log('倍速点击')
            //点击选择具体倍速按钮触发
            videoEventChange({ eventCode: 'video_speed_click', eventType: 'CLK', params: { speed_type: to } })
        })
        player.on('pause', function () {
            // console.log('视频暂停点击')
            //点击视频播放暂停按钮时触发
            videoEventChange({ eventCode: 'video_pause_click', eventType: 'CLK' })
        })
        player.on('playing', function () {
            // console.log('视频播放恢复点击')
            //点击视频播放恢复按钮时触发
            videoEventChange({ eventCode: 'continue_pybk_click', eventType: 'CLK' })
        })

        function videoEventChange({ eventCode, eventType = 'OTHER', params = {} }) {
            const {
                platform,
                video_name,
                video_id,
                resource_id,
                resource_name,
                video_duration
            } = player.config.eventStatisticsParams || {}
            const request_id = uuidv4()
            //深度埋码统计
            window.depthStatistics && window.depthStatistics({
                platform, params: {
                    action: 'aplus.record',
                    arguments: [eventCode, eventType, {
                        ...params,
                        video_name,
                        video_id,
                        resource_id,
                        resource_name,
                        request_id
                    }]
                }
            })
        }

        function uuidv4() {
            let rd = Math.random
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = rd() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
        }
    }
    try {
        if (!Player) return
        console.log('播放器行为统计插件初始化')
        Player.install('videoEventStatisticsPlugin', videoEventStatisticsPlugin)
    } catch {
    }


    try {
        //字幕拖放插件
        var textTrackGrag = async (player) => {
            if (!player.config.textTrackGrag) return
            function initTextTrackDarg() {
                let innerEl = jQuery('.xg-text-track xg-text-track-inner')
                jQuery('.xg-text-track').css({ 'pointer-events': 'all' }).on('mouseenter', function (end) {
                    jQuery(this).css({ cursor: 'move' })
                })
                //获取初始位置
                let currentLeft = innerEl.css('left')
                let currentBottom = (parseInt(innerEl.css('bottom')) || 0) + 'px'
                let maxBottom = parseInt(jQuery('.xgplayer video').height()) - parseInt(jQuery('.xg-text-track').css('bottom')) - 33
                innerEl.css({ position: 'absolute', left: currentLeft, bottom: currentBottom })
                innerEl.on('mousedown', function (start) {
                    let that = this
                    //移动开始位置
                    let startLeft = parseInt(jQuery(this).css('left'))
                    let startBottom = parseInt(jQuery(this).css('bottom'))
                    let startX = start.clientX
                    let startY = start.clientY
                    jQuery(document).on('mousemove', function (end) {
                        let endLeft = parseInt(jQuery('.xg-text-track').css('left'))
                        let x = end.clientX - startX + startLeft
                        let y = startY - end.clientY + startBottom
                        x = x > 0 ? x : 0
                        y = (y > 0 && y < maxBottom) ? y : y > maxBottom ? maxBottom : 0
                        innerEl.css({
                            left: x + 'px',
                            bottom: y + 'px',
                        })
                    })
                })
                jQuery(document).on('mouseup', function () {
                    jQuery(this).unbind('mousemove')
                })
            }
            player.on('play', function () {
                setTimeout(() => { initTextTrackDarg() }, 50)
            })
            player.on('requestFullscreen', function () {
                setTimeout(() => { initTextTrackDarg() }, 50)
            })
            player.on('exitFullscreen', function () {
                setTimeout(() => { initTextTrackDarg() }, 50)
            })
        }
        if (!Player) return
        console.log('字幕拖放插件初始化')
        Player.install('textTrackGrag', textTrackGrag)
    } catch (err) {
        // console.info(err)
    }


    //虚拟播放器进度条插件
    var videoProgressCustom = async (player) => {
        let dragProgressFlag = false
        if (!player.config.customProgress) return
        const addZero = (value = 0) => `${value > 9 ? value : `0${value}`}`;

        const dealTime = (time = 0) => {
            time = time / 10000000
            if (time < 0) {
                return '00:00'
            } else if (time < 60) {
                return `00:${addZero(Math.ceil(time))}`;
            } else {
                const min = Math.floor(time / 60);
                const seconds = Math.ceil(time - min * 60);
                return `${addZero(min)}:${addZero(seconds)}`;
            }
        };

        // console.log(player.config.videoHistoryParams)
        // let {id, chapterId, courseId, sectionId, subsectionId, videoId} = player.config.videoHistoryParams
        let { inpoint = 0, outpoint = 0 } = player.config.customProgress
        let total = outpoint - inpoint
        console.log('customProgress', player.config.customProgress)
        player.once('ready', function () {
            console.log('ready')
            console.log(player)
            let controlsDom = jQuery(player.controls)
            controlsDom.find('.xgplayer-progress').css({ display: 'none' })
            //添加虚拟进度条
            controlsDom.prepend(`
          <div class="video_progress_custom">
              <div class="r-prg-outer">
                  <div class="r-prg-played" style="width:0%">
                      <div class="r-prg-btn"></div>
                  </div>
              </div>
          </div>
          `)
            function setProgress(offsetX, e) {
                let x = offsetX < 0 ? 0 : offsetX
                let el = e.currentTarget
                let width = jQuery(el).width()
                let scale = (x / width)
                let innerWidth = scale * 100 + '%'
                player.currentTime = (scale * total + inpoint) / 10000000
                jQuery(el).find('.r-prg-played').css({ width: innerWidth })
            }
            setTimeout(() => {
                jQuery(player.root).find('.video_progress_custom').on('touchstart', function (e) {
                    dragProgressFlag = true
                    let startX = jQuery(e.currentTarget).offset().left
                    // setProgress(e.touches[0].clientX - startX, e)
                    jQuery(document).on('touchmove', function (el) {
                        setProgress(el.touches[0].clientX - startX, e)
                    })
                    jQuery(document).on('touchend', function (el) {
                        jQuery(document).unbind('touchmove')
                        jQuery(document).unbind('touchend')
                        dragProgressFlag = false
                    })
                })
                jQuery(player.root).find('.video_progress_custom').on('mousedown', function (e) {
                    dragProgressFlag = true
                    // setProgress(e.offsetX, e)
                    jQuery(document).on('mousemove', function (el) {
                        setProgress(el.offsetX, e)
                    })
                    jQuery(document).on('mouseup', function (el) {
                        setProgress(el.offsetX, e)
                        jQuery(document).unbind('mousemove')
                        jQuery(document).unbind('mouseup')
                        dragProgressFlag = false
                    })
                })
            }, 100)

            //定位首帧到知识点入点
            player.currentTime = inpoint / 10000000
        })

        player.on('play', function () {
            if (player.currentTime * 10000000 < inpoint) return player.currentTime = inpoint / 10000000 + 1
        })

        player.on('timeupdate', function () {
            let progressDom = jQuery(player.controls).find('.video_progress_custom')
            let current = player.currentTime * 10000000 - inpoint
            let innerWidth = Math.min(Number((current / total).toFixed(6)) * 100, 100)
            // console.log(current,inpoint,innerWidth)
            if (current < 0) {
                return player.currentTime = inpoint / 10000000
            }
            if (!dragProgressFlag) {
                progressDom.find('.r-prg-played').css({ width: innerWidth + '%' })
            }
            if (innerWidth >= 100) {
                //超出播放范围
                //   console.log('暂停')
                player.currentTime = inpoint / 10000000
                player.pause()
                player.emit('ended', player)
            }

            //修改时间
            jQuery(player.controls).find('.xgplayer-time').children().eq(1).text(dealTime(total))
            jQuery(player.controls).find('.xgplayer-time').children().eq(0).text(dealTime(current))
            // document.getElementsByClassName("xgplayer-time")[0].children[1].innerHTML = dealTime(total);
            // document.getElementsByClassName("xgplayer-time")[0].children[0].innerHTML = dealTime(current);
            //   console.log(dealTime(total),dealTime(current))

            //兼容记忆播放显示上次播放到...时间问题
            if (player.config.lastPlayTime) {
                player.once('play', function () {
                    jQuery(player.root).find('.xgplayer-lasttime').text(dealTime(player.config.lastPlayTime * 10000000 - inpoint))
                })
            }

        })
    }
    try {
        if (!Player) return
        console.log('虚拟播放器进度条插件初始化')
        Player.install('videoProgressCustom', videoProgressCustom)
    } catch {
    }


    //亮度、对比度调节插件
    var videoBrightnessContrast = async (player) => {
        let placeholderDom = ''
        player.controls.childNodes.forEach(d => {
            if (d.getAttribute('class').indexOf('xgplayer-placeholder') != -1) {
                placeholderDom = d
            }
        })
        if (!placeholderDom) return
        function initStyle() {
            var head = document.head || document.getElementsByTagName('head')[0];
            var style = document.createElement('style');
            var css = `
            .xgplayer-filter.drag_bar{
                width: 40px;
                position: relative;
                z-index: 120;
              }
              .xgplayer-filter.drag_bar .bar_group{
                width: auto;
                padding: 6px;
                box-sizing: border-box;
                position: absolute;
                left: 50%;
                bottom: 100%;
                transform: translateX(-50%);
                background-color: rgba(0,0,0,.54);;
                color: hsla(0,0%,100%,.8);
                max-width: 200px;
                display: none;
                z-index: 120;
              }
              .xgplayer-filter.drag_bar .drag_container{
                height: 100%;
                text-align: center;
              }
              .xgplayer-filter.drag_bar .drag_container > svg{
                width: 12px;
                height: 12px;
              }
              .xgplayer-filter.drag_bar > svg{
                width: 50%;
                height: 40px;
              }
              .xgplayer-filter.drag_bar .outer{
                width: 4px;
                height: 88px;
                border-radius: 99px;
                background-color: hsla(0,0%,100%,.3);
                margin: 0 6px;
                position: relative;
              }
              .xgplayer-filter.drag_bar .inner,
              .xgplayer-filter.drag_bar .drag{
                width: 100%;
                height: 100%;
                max-height: 100%;
                border-radius: 99px;
                background: #fa1f41;
                position: absolute;
                left: 0;
                bottom: 0;
                user-select: none;
              }
              .xgplayer-filter.drag_bar .drag{
                background: unset;
              }
              .xgplayer-filter.drag_bar .inner:after{
                content: '';
                display: block;
                position: absolute;
                width: 10px;
                height: 10px;
                border-radius: 99px;
                background-color: #fff;
                left: 50%;
                top:0;
                transform: translate(-50%,-50%);
              }
          `;
            style.appendChild(document.createTextNode(css));
            head.appendChild(style);
        }
        /**
         * 
         * @param {*} mainIcon 图标
         * @param {*} barArr 
         * @param {*} className 样式名
         * @param {*} callback 回调
         */
        function drawDragBar(iconDom, barArr, className = '', callback) {
            let parentDom = document.createElement('div')
            parentDom.setAttribute('class', 'drag_bar ' + className)
            parentDom.appendChild(iconDom)
            let barGroup = document.createElement('div')
            barGroup.setAttribute('class', 'bar_group')
            barArr.map(bar => {
                let barDom = document.createElement('div')
                barDom.setAttribute('class', 'drag_container')
                barGroup.appendChild(barDom)
                //绘制控制条
                let outer = document.createElement('div')
                outer.setAttribute('class', 'outer')
                let inner = document.createElement('div')
                inner.setAttribute('class', 'inner')
                let drag = document.createElement('div')
                drag.setAttribute('class', 'drag')
                inner.style.height = bar.defaultValue * 100 + '%'
                outer.appendChild(inner)
                outer.appendChild(drag)
                barDom.appendChild(outer)
                if (bar.icon) {
                    barDom.appendChild(bar.icon)
                }
                //控制条调节
                drag.onmousedown = function (e) {
                    let height = outer.clientHeight
                    inner.style.height = (height - e.offsetY) / height * 100 + '%'
                    let scale = (height - e.offsetY) / height
                    scale = scale < 0 ? 0 : scale
                    callback({ name: bar.name, value: scale })
                    let startY = e.screenY
                    let startHeight = parseFloat(inner.style.height) / 100
                    document.onmousemove = function (e) {
                        scale = (startY - e.screenY) / height + startHeight
                        scale = scale < 0 ? 0 : scale > 1 ? 1 : scale
                        inner.style.height = scale * 100 + '%'
                        callback({ name: bar.name, value: scale })
                    }
                    document.onmouseup = function () {
                        document.onmousemove = null
                        drag.onmouseup = null
                    }
                }
                drag.ontouchstart = function (e) {
                    let height = outer.clientHeight
                    let scale = (height - (e.touches[0].clientY - e.target.getBoundingClientRect().top)) / height
                    scale = scale < 0 ? 0 : scale
                    inner.style.height = scale * 100 + '%'
                    callback({ name: bar.name, value: scale })
                    let startY = e.touches[0].clientY
                    let startHeight = parseFloat(inner.style.height) / 100
                    document.ontouchmove = function (e) {
                        e.preventDefault()
                        scale = (startY - e.touches[0].clientY) / height + startHeight
                        scale = scale < 0 ? 0 : scale > 1 ? 1 : scale
                        inner.style.height = scale * 100 + '%'
                        callback({ name: bar.name, value: scale })
                    }
                    document.ontouchend = function (e) {
                        document.ontouchmove = null
                        document.ontouchend = null
                    }
                }
            })
            parentDom.onmouseover = function () {
                barGroup.style.display = 'flex'
            }
            parentDom.onmouseleave = function () {
                barGroup.style.display = 'none'
            }
            parentDom.appendChild(barGroup)
            return parentDom
        }
        player.once('ready', function () {
            initStyle()
            let adjustIconPath = 'M202.666667 320a32 32 0 0 1 32 32l0.021333 207.082667a117.376 117.376 0 0 1 0 225.834666L234.666667 906.666667a32 32 0 0 1-64 0v-121.749334a117.376 117.376 0 0 1 0-225.834666V352A32 32 0 0 1 202.666667 320z m320-234.666667A32 32 0 0 1 554.666667 117.333333l0.021333 164.416a117.376 117.376 0 0 1 0 225.834667L554.666667 906.666667a32 32 0 0 1-64 0V507.584a117.376 117.376 0 0 1 0-225.834667V117.333333A32 32 0 0 1 522.666667 85.333333z m298.666666 384a32 32 0 0 1 32 32l0.021334 100.416a117.376 117.376 0 0 1 0 225.834667L853.333333 906.666667a32 32 0 0 1-64 0v-79.082667a117.376 117.376 0 0 1 0-225.834667V501.333333a32 32 0 0 1 32-32z m0 192a53.333333 53.333333 0 1 0 0 106.666667 53.333333 53.333333 0 0 0 0-106.666667z m-618.666666-42.666666a53.333333 53.333333 0 1 0 0 106.666666 53.333333 53.333333 0 0 0 0-106.666666z m320-277.333334a53.333333 53.333333 0 1 0 0 106.666667 53.333333 53.333333 0 0 0 0-106.666667z'
            let saturateIconPath = 'M512 93.090909c43.163152 0 310.30303 272.911515 310.30303 489.223758C822.30303 757.201455 683.349333 899.878788 512 899.878788S201.69697 757.201455 201.69697 582.314667C201.69697 350.363152 460.737939 93.090909 512 93.090909z m-2.203152 31.402667l-1.024 0.341333c-19.921455 7.385212-89.801697 70.407758-146.46303 144.694303C282.158545 374.597818 232.727273 486.43103 232.727273 582.314667 232.727273 740.38303 358.120727 868.848485 512 868.848485s279.272727-128.465455 279.272727-286.533818c0-88.374303-50.703515-198.811152-132.654545-306.982788-32.954182-43.504485-68.980364-83.626667-101.065697-113.508849a350.952727 350.952727 0 0 0-37.422546-31.030303 101.996606 101.996606 0 0 0-8.657454-5.430303l-1.675637-0.868848z m155.772122 311.482182a217.212121 217.212121 0 0 1-307.2 307.2l307.2-307.2z'
            let contrastIconPath = 'M512 70.13093663c247.44667549 0 441.86906337 194.42238788 441.86906337 441.86906337S759.44667549 953.86906337 512 953.86906337z m0 927.92503309c-265.12143803 0-486.05596972-220.9345317-486.05596972-486.05596972s220.9345317-486.05596972 486.05596972-486.05596972 486.05596972 220.9345317 486.05596972 486.05596972-220.9345317 486.05596972-486.05596972 486.05596972z m0-883.73812675c-220.9345317 0-397.68215703 176.74762534-397.68215703 397.68215703s176.74762534 397.68215703 397.68215703 397.68215703 397.68215703-176.74762534 397.68215703-397.68215703-176.74762534-397.68215703-397.68215703-397.68215703z'
            let brightnessIconPath = 'M512.1 801.5c-158.1 0-289.8-131.7-289.8-289.8S354 221.8 512.1 221.8s289.8 131.7 289.8 289.8-131.7 289.9-289.8 289.9z m0-52.7c131.7 0 237.1-105.4 237.1-237.1S643.9 274.5 512.1 274.5 275 379.9 275 511.7s105.4 237.1 237.1 237.1zM485.8 63.7h52.7v105.4h-52.7V63.7z m0 790.5h52.7v105.4h-52.7V854.2zM960 485.3V538H854.6v-52.7H960z m-790.4 0V538H64.2v-52.7h105.4z m642.9-310.9l36.9 36.9-73.8 73.8-36.9-36.9 73.8-73.8zM253.9 733l36.9 36.9-73.8 73.7-36.9-36.9 73.8-73.7z m595.5 79l-36.9 36.9-73.8-73.8 36.9-36.9 73.8 73.8zM290.8 253.4l-36.9 36.9-79-79 36.9-36.9 79 79z'
            let adjustBtn = drawDragBar(drawSvg([adjustIconPath]), [{
                name: 'saturate',
                defaultValue: 0.5,
                icon: drawSvg([saturateIconPath])
            }, {
                name: 'brightness',
                defaultValue: 0.5,
                icon: drawSvg([brightnessIconPath])
            }, {
                name: 'contrast',
                defaultValue: 0.5,
                icon: drawSvg([contrastIconPath])
            }], 'xgplayer-filter', function (valObj) {
                let val = valObj.value
                let styles = player.root.style
                let filterStr = styles.filter || styles.webkitFilter || styles.mozFilter || styles.msFilter || styles.oFilter || ''
                if (valObj.name == 'saturate') {
                    //饱和度最大10
                    let saturate = 1
                    if (val > 0.5) {
                        saturate = 1 + (val - 0.5) * 2 * (10 - 1)
                    } else {
                        saturate = val * 2
                    }
                    console.log(saturate)
                    if (filterStr.includes('saturate')) {
                        player.video.style.filter = filterStr.replace(/saturate\((.*?)\)/, 'saturate(' + saturate + ')')
                    } else {
                        player.video.style.filter = filterStr + ' saturate(' + saturate + ')'
                    }
                } else if (valObj.name == 'brightness') {
                    //亮度最大值为20
                    let brightness = 1
                    if (val > 0.5) {
                        brightness = 1 + (val - 0.5) * 2 * (20 - 1)
                    } else {
                        brightness = val * 2
                    }
                    if (filterStr.includes('brightness')) {
                        player.video.style.filter = filterStr.replace(/brightness\((.*?)\)/, 'brightness(' + brightness + ')')
                    } else {
                        player.video.style.filter = filterStr + ' brightness(' + brightness + ')'
                    }
                } else if (valObj.name == 'contrast') {
                    //对比度最大值为4
                    let contrast = 1
                    if (val > 0.5) {
                        contrast = 1 + (val - 0.5) * 2 * (4 - 1)
                    } else {
                        contrast = val * 2
                    }
                    if (filterStr.includes('contrast')) {
                        player.video.style.filter = filterStr.replace(/contrast\((.*?)\)/, 'contrast(' + contrast + ')')
                    } else {
                        player.video.style.filter = filterStr + ' contrast(' + contrast + ')'
                    }
                }
            })
            adjustBtn.style.order = 3
            player.controls.appendChild(adjustBtn)
        })
    }
    try {
        if (!Player) return
        console.log('亮度调节插件初始化')
        Player.install('videoBrightnessContrast', videoBrightnessContrast)
    } catch {
    }

    //多语言字幕插件
    var multiTextTrack = async (player) => {
        player.setMultiTextTrack = function (lans) {
            //插入字幕按钮
            let parentDom = player.root.querySelector('xg-controls');
            if (!parentDom) return
            let multiTextTrackBtnDom = document.createElement('xg-texttrack')
            parentDom.appendChild(multiTextTrackBtnDom)
            multiTextTrackBtnDom.classList.add('xgplayer-texttrack')
            multiTextTrackBtnDom.style.display = 'block'
            multiTextTrackBtnDom.style.zIndex = 35
            multiTextTrackBtnDom.setAttribute('tabindex', 7)
            let ulDom = document.createElement('ul')
            multiTextTrackBtnDom.appendChild(ulDom)
            let closeBtn = document.createElement('li')
            closeBtn.setAttribute('data-type', 'off')
            closeBtn.innerHTML = '关闭'
            ulDom.appendChild(closeBtn)
            let i = 0
            let lis = [closeBtn]
            lans.map((lan, i) => {
                let li = document.createElement('li')
                li.setAttribute('data-id', i)
                li.setAttribute('data-language', lan.srclang)
                li.innerHTML = lan.lable
                ulDom.appendChild(li)
                lis.push(li)
                i++
            })
            let p = document.createElement('p')
            multiTextTrackBtnDom.appendChild(p)
            p.classList.add('name')
            p.innerHTML = '字幕'
            p.onmouseover = function () {
                ulDom.style.display = 'block'
            }
            multiTextTrackBtnDom.onmouseleave = function () {
                ulDom.style.display = 'none'
            }
            //定义开关
            let openLans = []
            //字幕数据
            let dataSource = {}
            //获取所有语言字幕
            lans.map((lan, i) => {
                try {
                    fetch(lan.src).then(res => res.text()).then(async (text) => {
                        const data = await vttToJson(text)
                        data.map((el) => {
                            el.part = el.part.replaceAll('\r', '')
                        })
                        dataSource[lan.srclang] = data
                    })
                } catch { }
            })
            //定义逻辑
            lis.map((li, i) => {
                li.onclick = function () {
                    const defaultLans = lans.map(el => el.srclang)
                    if (li.classList.contains('selected')) {
                        //关闭
                        li.classList.remove('selected')
                        if (li.getAttribute('data-type') != 'off') {
                            openLans = openLans.filter(srclang => srclang != li.getAttribute('data-language'))
                            document.querySelector(`xg-text-track [data-language=${li.getAttribute('data-language')}]`)?.remove()
                        } else {
                            document.querySelector('xg-text-track').innerHTML = ''
                        }
                    } else {
                        //打开
                        li.classList.add('selected')
                        if (li.getAttribute('data-type') == 'off') {
                            //关闭所有字幕
                            openLans.length = 0
                            lis.map(li => li.classList.remove('selected'))
                        } else {
                            openLans = defaultLans.filter(srclang => srclang == li.getAttribute('data-language') || openLans.includes(srclang))
                        }
                    }
                }
            })
            let curtText = {}
            //是否拖拽
            let dragFlag = false
            let moveX, moveY, moveWidth
            let textTrackInner
            //结束后最多展示20s
            player.on('timeupdate', function (p) {
                if (!document.querySelector('xg-text-track') || dragFlag) return
                const currentTime = p.currentTime * 1000
                if (openLans.length) {
                    document.querySelector('xg-text-track')?.classList.remove('text-track-hide')
                    let refreshFlag = false
                    openLans.map(lan => {
                        if (dataSource[lan]) {
                            let text = dataSource[lan].find(item => item.start <= currentTime && item.end >= currentTime)
                            if (text?.part && curtText[lan] != text?.part) {
                                refreshFlag = true
                                curtText[lan] = text?.part
                            }
                        }
                    })
                    if (!refreshFlag) return
                    const inner = document.createElement('xg-text-track-inner')
                    inner.style.position = 'absolute'
                    inner.style.bottom = '0'
                    inner.style.left = moveX ?? 'auto'
                    inner.style.marginBottom = moveY ?? '50px'
                    inner.style.width = moveWidth ?? 'auto'
                    openLans.map(key => {
                        const span = document.createElement('xg-text-track-span')
                        span.setAttribute('data-language', key)
                        span.classList.add('text-track-double')
                        inner.appendChild(span)
                        span.innerHTML = curtText[key]
                    })
                    if (document.querySelector('xg-text-track') && inner) {
                        document.querySelector('xg-text-track').innerHTML = ''
                        document.querySelector('xg-text-track')?.appendChild(inner)
                        setTimeout(() => {
                            //最多展示20秒，防止字幕结束视频未结束一直显示
                            document.querySelector('xg-text-track').innerHTML = ''
                        }, 20 * 1000);
                    }
                    inner.onmousedown = function (s) {
                        dragFlag = true
                        let textTrackContentDom = s.currentTarget;
                        let sx = s.clientX;
                        let sy = s.clientY;
                        let smx = parseInt(textTrackContentDom.style.marginLeft) || 0;
                        let smy = parseInt(textTrackContentDom.style.marginBottom) || 0;
                        let startX = parseFloat(textTrackContentDom.style.left == 'auto' ? 0 : textTrackContentDom.style.left)
                        player.root.onmousemove = function (m) {
                            let mx = m.clientX - sx + smx;
                            let my = sy - m.clientY + smy;
                            my = my < 0 ? 0 : my;
                            moveX = startX + mx + "px"
                            moveY = my + "px"
                            moveWidth = `calc(100% - ${startX + mx}px)`
                            textTrackContentDom.style.left = moveX;
                            textTrackContentDom.style.width = moveWidth;
                            textTrackContentDom.style.marginBottom = moveY;
                        };
                        document.onmouseup = function (u) {
                            dragFlag = false;
                            player.root.onmousemove = null;
                        };
                    }
                } else {
                    document.querySelector('xg-text-track')?.classList.add('text-track-hide')
                }
            })
            let dragDom = document.querySelector('xg-text-track-inner')
        }
    }
    try {
        if (!Player) return
        console.log('多语言字幕插件初始化')
        Player.install('multiTextTrack', multiTextTrack)
    } catch {
    }

})()